import React, { useState, useEffect } from "react";
import TextareaAutosize from 'react-textarea-autosize';
import { toast } from "react-toastify";
import { createUsefulInfo, updateUsefulInfo } from "../services/usefulInfoService";
import "../styles/components/form.css";
import CloseIcon from "../assets/icons/close-icon.svg";
import Loader from "../components/Loader";

const UsefullInfoForm = ({ onClose, initialData, mode, onSuccess }) => {
    const getCurrentLocalDate = () => {
        const now = new Date();
        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, '0');
        const day = String(now.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    const [usefulInfoDate, setUsefulInfoDate] = useState(
        initialData?.createdAt || (mode === "create" ? getCurrentLocalDate() : "")
    );
    const [usefulInfoTitle, setUsefulInfoTitle] = useState(initialData?.title || "");
    const [usefulInfoDescription, setUsefulInfoDescription] = useState(initialData?.description || "");

    const [isSubmitting, setIsSubmitting] = useState(false);

    const isFormValid =
        usefulInfoDate.trim() !== "" &&
        usefulInfoTitle.trim() !== "" &&
        usefulInfoDescription.trim() !== "";

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);

        try {
            const data = {
                title: usefulInfoTitle,
                description: usefulInfoDescription,
                createdAt: usefulInfoDate
            };

            if (mode === "edit") {
                await updateUsefulInfo(initialData.id, data);
                toast.success("Изменения сохранены", {
                    position: "bottom-left",
                    autoClose: 3000
                });
            } else {
                await createUsefulInfo(data);
                toast.success("Полезная информация создана", {
                    position: "bottom-left",
                    autoClose: 3000
                });
            }

            onSuccess?.();
            onClose();
        } catch (error) {
            console.error("Ошибка сохранения:", error);
            toast.error(`Ошибка: ${error.message || "Неизвестная ошибка"}`, {
                position: "bottom-left",
                autoClose: 3000
            });
        } finally {
            setIsSubmitting(false);
        }
    };


    useEffect(() => {
        document.body.style.overflow = "hidden";
        return () => {
            document.body.style.overflow = "auto";
        };
    }, []);

    return (
        <div className="modal-overlay">
            <div className="form">
                <div className="form-header">
                    <h1 className="form-title">
                        {mode === "edit" ? "Редактирование полезной информации" : "Создание полезной информации"}
                    </h1>
                    <button className="close-button" onClick={onClose}>
                        <img src={CloseIcon} alt="Закрыть" />
                    </button>
                </div>
                <form onSubmit={handleSubmit}>
                    <h2 className="form-section-title">Информация полезной информации</h2>

                    <div className="form-group">
                        <label className="field-label">Дата полезной информации</label>
                        <input
                            type="date"
                            className="date-input"
                            value={usefulInfoDate}
                            onChange={(e) => setUsefulInfoDate(e.target.value)}
                            required
                        />
                    </div>

                    <div className="form-group">
                        <label className="field-label">Заголовок полезной информации</label>
                        <TextareaAutosize
                            className="textarea-input"
                            placeholder="Введите заголовок полезной информации"
                            value={usefulInfoTitle}
                            onChange={(e) => setUsefulInfoTitle(e.target.value)}
                            required
                        />
                    </div>

                    <div className="form-group">
                        <label className="field-label">Описание полезной информации</label>
                        <TextareaAutosize
                            className="textarea-input"
                            placeholder="Введите описание полезной информации"
                            value={usefulInfoDescription}
                            onChange={(e) => setUsefulInfoDescription(e.target.value)}
                            required
                        />
                    </div>

                    <div className="form-buttons">
                        <button type="button" className="cancel-button" onClick={onClose}>
                            Отменить
                        </button>
                        <button
                            type="submit"
                            className="save-button"
                            disabled={!isFormValid || isSubmitting}
                        >
                            Сохранить
                        </button>
                    </div>
                </form>
                {isSubmitting && (
                    <div className="loader-overlay">
                        <Loader />
                        <p>Сохранение полезной информации...</p>
                    </div>
                )}
            </div>
        </div>
    );
};

export default UsefullInfoForm;